import CookieConsentComponent from './CookieConsentComponent';

export default CookieConsentComponent;
